export enum TravelWithType {
  Solo = 'Solo',
  Couple = 'Couple',
  Friends = 'Friends',
  Family = 'Family'
}
